module.exports = __webpack_public_path__ + "static/tablet_hor-bbbb9a454e705c554ee04ccb61c0e15e.svg";